export const socialLoginOptions = {
  'apple': {
    // fallback title is used, if there is no translation
    fallbackTitle: 'Login through Apple',
    backgroundColor: '#000000',
    textColor: '#ffffff',
    icon: 'mdi-apple',
    img: '',
    network: 'apple',
  },
  'facebook': {
    // fallback title is used, if there is no translation
    fallbackTitle: 'Login through Facebook',
    backgroundColor: '#4267B2',
    textColor: '#ffffff',
    icon: 'mdi-facebook',
    img: '',
    network: 'facebook',
  },
  'google': {
    // fallback title is used, if there is no translation
    fallbackTitle: 'Login through Google',
    backgroundColor: '#ffffff',
    textColor: '#000000',
    icon: '',
    img: require('@/assets/pictures/google_icon.svg'),
    network: 'google',
  },
}
